import React from 'react';
import { createPortal } from 'react-dom';
import Button from './Button';

const ConfirmModal = ({
  isOpen,
  title = 'Confirm',
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
}) => {
  if (!isOpen) return null;

  // Portaled to document.body: this component renders wherever it's used in
  // the tree (often deep inside page layout), and `fixed` only reliably
  // covers the actual viewport — not just its nearest positioned ancestor —
  // when it isn't nested inside anything that could scope it (padding,
  // scroll containers, etc. further up the page).
  return createPortal(
    <div className="fixed inset-0 bg-ink/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-xl border border-ink-line shadow-card-hover p-6 w-full max-w-sm">
        <h2 className="text-lg font-medium text-ink">{title}</h2>
        <p className="text-sm text-ink-body mt-2">{message}</p>
        <div className="flex justify-end gap-2 mt-6">
          <Button variant="outline" size="md" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={variant} size="md" onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
